export function emailIsValidFormat(str) {
  // eslint-disable-next-line
  const regex =
    /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+$/;
  return regex.test(str);
}
